// extracted by mini-css-extract-plugin
module.exports = {"container":"Landing_container__nmErf","btnHome":"Landing_btnHome__v2NQW","btnText":"Landing_btnText__2g9iq"};